<template>
  <div>
    <el-row>
      <el-col :span="1">签约状态</el-col>
      <el-col :span="5">
        <jm-dict-select
          :disabled="infoReadOnly"
          @change="bindUserSignStatus"
          class="jm-input-common4"
          clearable
          type="dataset"
          v-model="editData.custom_level"
          dict-type="student"
          name="customLevelType"
        />
      </el-col>
      <el-col :span="1">签约日期</el-col>
      <el-col :span="5">
        <el-date-picker
          :readonly="infoReadOnly"
          class="jm-input-common4"
          v-model="editData.signing_date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        />
      </el-col>
      <el-col :span="12"></el-col>
    </el-row>
    <el-row class="activeCountry">
      <el-col class="activeCountry_box">办理国家</el-col>
      <el-col class="activeCountry_checkbox" style="flex-wrap: wrap" :class="countryCheckboxLock[0] && active_countries.length > 0 ? 'col-border-light' : ''">
        <el-checkbox-group v-model="active_countries" @change="changeCountries($event, activeCountry)" v-show="countryCheckboxLock[0] === false && active_countries.length > 0">
          <el-checkbox
            v-for="item in activeCountry"
            v-show="active_countries.indexOf(item.id) > -1"
            :label="item.id"
            :key="item.id"
            :disabled="isDisabledCountry(item.id)"
            :class="addClass(item.id)"
          >{{ item.value }}</el-checkbox>
        </el-checkbox-group>
        <el-checkbox-group v-model="active_countries" @change="changeCountries($event, activeCountry)" v-show="countryCheckboxLock[0] === true || active_countries.length < 1">
          <el-checkbox
            v-for="item in activeCountry"
            :label="item.id"
            :key="item.id"
            :disabled="isDisabledCountry(item.id)"
            :class="addClass(item.id)"
          >{{ item.value }}</el-checkbox>
        </el-checkbox-group>
        <div style="width: 100%; padding-bottom: 10px" v-show="active_countries.length > 0">
          <el-button
            class="country-button"
            type="primary"
            size="medium"
            @click="countryCheckboxClick(1)">{{ countryCheckboxLock[0] ? '收起国家' : '更多国家' }}</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="1">合同号</el-col>
      <el-col :span="5">
        <el-input
          :readonly="infoReadOnly"
          v-model="editData['contract_number']"
          class="jm-input-common4"
        />
      </el-col>
      <el-col :span="1">代言计划</el-col>
      <el-col :span="5">
        <jm-dict-select
          :disabled="rugbyDisable"
          class="jm-input-common4"
          clearable
          v-model="editData.rugby_people"
          type="dataset"
          dict-type="student"
          name="rugbyPeople"
        />
      </el-col>
      <template v-if="editData.id && isLanguageSchool">
        <el-col :span="1">申请学校</el-col>
        <el-col :span="11">
          <jm-school-search
            class="jm-input-common4"
            style="margin-right: 10px"
            :country-id="83"
            ref="school_search"
            :value="interviewSchool"
            @change="selectSchool"
          />
          <el-button
            type="primary"
            size="medium"
            :disabled="!canConfirmSchool"
            @click="confirmInterview"
          >预约</el-button>
          <el-button
            type="primary"
            size="medium"
            @click="showSchoolLogs = true"
          >历史</el-button>
        </el-col>
      </template>
      <el-col v-else :span="12" />
    </el-row>
    <el-row v-if="$hasPermission([22, 54, 135, 136]) && isKoreaSchool">
      <el-col :span="1">项目类型</el-col>
      <el-col :span="5">
        <jm-dict-select
          class="jm-input-common4"
          clearable
          v-model="editData.korea_school_type"
          type="jiemo"
          dict-type="korea_school_type"
          @change="showKrSchool(1,editData.korea_school_type)"
        />
      </el-col>
      <el-col :span="1">选择学校</el-col>
      <el-col :span="5" style="justify-content: flex-start">
        <el-button :type="buttonStyle" @click="showKrSchool(2)" style="margin: 0">选择学校</el-button>
      </el-col>
      <el-col :span="12">
        <el-input v-if="showSchool.kr_fir_id" :value="showSchool.kr_fir_id" disabled="true"></el-input>
        <el-input v-if="showSchool.kr_sec_id" :value="showSchool.kr_sec_id" disabled="true"></el-input>
        <el-input v-if="showSchool.kr_thr_id" :value="showSchool.kr_thr_id" disabled="true"></el-input>
        <el-input v-if="showSchool.kr_fou_id" :value="showSchool.kr_fou_id" disabled="true"></el-input>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="1">咨询老师</el-col>
      <el-col :span="5">
        <el-select
          v-model="editData.crm_sayer"
          :disabled="!canEditSayer && !$hasPermission([161])"
          class="jm-input-common4"
          placeholder="请选择"
          filterable
        >
          <el-option-group v-for="(group, k) in teachers['advisory_teacher']" :key="k" :label="k">
            <el-option
              v-for="item in group"
              :key="item.userid"
              :label="item.truename"
              :value="item.userid"
            />
          </el-option-group>
        </el-select>
      </el-col>
      <el-col :span="1">申请老师</el-col>
      <el-col :span="5">
        <el-select
          :disabled="!canEditApply"
          v-model="editData['crm_writer']"
          class="jm-input-common4"
          style="margin-right: 10px"
          clearable
          placeholder="请选择"
          filterable
          ref="crmWriterSelect"
        >
          <el-option-group v-for="(group, k) in teachers['write_teacher']" :key="k" :label="k">
            <el-option
              v-for="item in group"
              :key="item.userid"
              :label="item.truename"
              :value="item.userid"
            />
          </el-option-group>
        </el-select>
      </el-col>
      <!-- 日本语言学校择校信息，同步面试系统 -->
      <el-col :span="12">
        <span class="c-spe" v-if="editData.id && isLanguageSchool">
          <el-checkbox
            v-model="editData.interview_special_channel"
            :true-label="1"
            :false-label="0"
          >特殊渠道</el-checkbox>
        </span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="1">规划老师</el-col>
      <el-col :span="5">
        <el-select
          :disabled="!$hasPermission([1, 20, 43, 140])"
          v-model="editData['crm_planning']"
          class="jm-input-common4"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option-group v-for="(group, k) in teachers.planning_teacher" :key="k" :label="k">
            <el-option
              v-for="item in group"
              :key="item.userid"
              :label="item.truename"
              :value="item.userid"
            />
          </el-option-group>
        </el-select>
      </el-col>
      <el-col :span="1">文书老师</el-col>
      <el-col :span="5">
        <el-select
          :disabled="!canEditWriter"
          v-model="editData['crm_document']"
          class="jm-input-common4"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option-group v-for="(group, k) in teachers.document_teacher" :key="k" :label="k">
            <el-option
              v-for="item in group"
              :key="item.userid"
              :label="item.truename"
              :value="item.userid"
            />
          </el-option-group>
        </el-select>
      </el-col>
      <el-col :span="1">资料发送</el-col>
      <el-col :span="11">
        <el-select
          :disabled="infoReadOnly"
          clearable
          class="jm-input-common4"
          placeholder="请选择"
          v-model="material_send"
          @change="changeSendMetrial"
        >
          <el-option
            v-for="item in materialData"
            :key="item.id"
            :label="`[${item.country}]${item.value}`"
            :value="item.id"
          />
        </el-select>
      </el-col>
    </el-row>
    <el-row v-if="$hasPermission([20,101,54])">
      <el-col :span="1">签署合同</el-col>
      <el-col :span="5">
        <el-select class="jm-input-common4" v-model="editData.signing_contract_flag" clearable placeholder="请选择">
          <el-option
            v-for="item in contractFlagOps"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="1">签署合同日期</el-col>
      <el-col :span="5">
        <el-date-picker
          :readonly="infoReadOnly"
          class="jm-input-common4"
          v-model="editData.signing_contract_date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        />
      </el-col>
      <el-col :span="1">电子协议</el-col>
      <el-col :span="5">
        <jm-upload
          :show-file-list="false"
          action="/newfib.php/index/api_base/uploadSimpleFile/type/dzxy"
          :on-success="uploadDzxySuccess"
        >
          <slot>
            <el-button type="warning" size="medium">
              <i class="el-icon-document"></i>上传电子协议
            </el-button>
          </slot>
        </jm-upload>
        <el-button v-if="editData['dzxy_file'] !== undefined && editData['dzxy_file'] !== ''" @click="downloadDzxy">
          <i class="el-icon-document"></i>下载电子协议
        </el-button>
      </el-col>
      <el-col :span="6">
      </el-col>
    </el-row>
    <el-row>
      <el-col v-if="editData.id && $hasPermission([19,58,20,101,54,135,136,140,141]) && !infoReadOnly" :span="1">上传<br>报名表</el-col>
      <el-col v-if="editData.id && $hasPermission([19,58,20,101,54,135,136,140,141]) && !infoReadOnly" :span="5">
        <!-- 只有芥末日韩显示 -->
        <template>
          <jm-upload-file
            url="/newfib.php/index/apply_file/upload"
            :upload-data="{crm_id: editData.id}"
            :show-file-list="true"
            :upload-additional="{
              upload_position: '报名表资料',
              upload_type_str: '报名表资料',
              offer_school_id: 0,
              offer_id: 0,
              country_id: 0
            }"
            :before-upload="beforeSignupFileUpload"
            :files-list.sync="uploadedSignFormReplaced"
          >
            <template slot="uploadFile">
              <el-button type="primary" size="medium" class="button-upload-icon">上传报名表<span class="red">(旧数据专用)</span></el-button>
              <!-- <div class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
            </template>
          </jm-upload-file>
        </template>
      </el-col>
      <el-col :span="1" v-if="mustHaveInterviewForm">报名<br>采集表</el-col>
      <el-col :span="5" v-if="mustHaveInterviewForm">
        <el-button
          :type="hasSignUpForm ? 'success' : 'primary'"
          size="medium"
          @click="viewSignForm(83)"
          v-if="showInterviewBtn(83)"
        >日本</el-button>
        <el-button
          :type="hasSignUpForm ? 'success' : 'primary'"
          size="medium"
          @click="viewSignForm(672)"
          v-if="showInterviewBtn(672)"
        >韩国</el-button>
        <el-button
          :type="hasSignUpForm ? 'success' : 'primary'"
          size="medium"
          @click="viewSignForm(2061)"
          v-if="showInterviewBtn(2061)"
        >新马</el-button>
        <br>
        <span style="margin: 0 8px" v-if="hasSignUpForm && mustHaveInterviewForm && editData.signup_form.update_channel">
          {{ editData.signup_form.update_channel_name }}:
          {{ editData.signup_form.update_time }}
        </span>
      </el-col>
      <el-col v-if="editData.id && isLanguageSchool" :span="1">面试<br>专用表</el-col>
      <el-col v-if="editData.id && isLanguageSchool" :span="5">
        <template>
          <router-link
            target="_blank"
            :to="{ name: 'interview_signup_table', params: { crm_id: editData.id } }"
          >
            <el-button type="success" size="medium" v-if="currentInterviewObj.signup_form">面试专用表</el-button>
            <el-button type="primary" size="medium" v-else>面试专用表</el-button>
          </router-link>
          <span style="margin: 0 8px">面试时间：{{ currentInterviewObj.interview_time || '未排期' }}</span>
        </template>
      </el-col>
      <el-col :span="1">合格证</el-col>
      <el-col :span="5">
        <el-button
          type="primary"
          size="medium"
          :disabled="!currentInterviewObj.asset_id"
          @click="downloadCert(currentInterviewObj.asset)"
        >{{ currentInterviewObj.asset_id ? '查看合格证' : '合格证未上传' }}</el-button>
      </el-col>
    </el-row>
    <el-row v-if="editData.id && (currentInterviewObj.is_special || (editData.custom_course_type === 1 && $hasPermission([39,43,74,75,76]))) && !infoReadOnly">
      <el-col :span="1">上传<br>报名表</el-col>
      <el-col :span="23">
        <template>
          <jm-upload-file
            url="/newfib.php/index/apply_file/upload"
            :upload-data="{crm_id: editData.id}"
            :show-file-list="true"
            :upload-additional="{
              upload_position: '报名表资料',
              upload_type_str: '报名表资料',
              offer_school_id: 0,
              offer_id: 0,
              country_id: 0
            }"
            :before-upload="beforeSignupFileUpload"
            :files-list.sync="uploadedSignForm"
          >
            <template slot="uploadFile">
              <el-button type="primary" size="medium" class="button-upload-icon">上传报名表</el-button>
              <!-- <div class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
            </template>
          </jm-upload-file>
        </template>
      </el-col>
    </el-row>

    <school-logs :visible.sync="showSchoolLogs" />
    <kr-form-dialog ref="kr" :visible.sync="krSchoolVisible" :show-data="krSchool"/>
  </div>
</template>

<script>
import _ from 'lodash';
import { jmDictSelect, jmUploadFile, jmSchoolSearch } from '@/components/tool';
import schoolLogs from './schoolLogs';
import permissionMixin from '../permissionMixin';
import { isEmpty } from '@/utils/utils';
import krFormDialog from './krSchoolForm';
import vueClint from 'vue';

const UUCountries = [
  {
    id: 30, value: '英国', pid: 0, type: 'country'
  },
  {
    id: 31, value: '澳洲', pid: 0, type: 'country'
  },
  {
    id: 471, value: '美国', pid: 0, type: 'country'
  },
  {
    id: 486, value: '加拿大', pid: 0, type: 'country'
  },
  {
    id: 673, value: '新西兰', pid: 0, type: 'country'
  },
  {
    id: 674, value: '爱尔兰', pid: 0, type: 'country'
  },
];
const UCCountries = [
  {
    id: 1770, value: '香港', pid: 0, type: 'country'
  },
  {
    id: 1831, value: '法国', pid: 0, type: 'country'
  },
  {
    id: 1867, value: '瑞士', pid: 0, type: 'country'
  },
  {
    id: 1869, value: '德国', pid: 0, type: 'country'
  },
  {
    id: 1870, value: '意大利', pid: 0, type: 'country'
  },
  {
    id: 1871, value: '西班牙', pid: 0, type: 'country'
  },
  {
    id: 1872, value: '荷兰', pid: 0, type: 'country'
  },
  {
    id: 1874, value: '瑞典', pid: 0, type: 'country'
  },
  {
    id: 1875, value: '丹麦', pid: 0, type: 'country'
  },
  {
    id: 1876, value: '挪威', pid: 0, type: 'country'
  },
  {
    id: 1877, value: '芬兰', pid: 0, type: 'country'
  },
  {
    id: 1879, value: '俄罗斯', pid: 0, type: 'country'
  },
  {
    id: 1839, value: '澳门', pid: 0, type: 'country'
  },
  {
    id: 1878, value: '比利时', pid: 0, type: 'country'
  },
  {
    id: 2061, value: '新加坡', pid: 0, type: 'country'
  },
  {
    id: 672, value: '韩国', pid: 0, type: 'country'
  },
  {
    id: 83, value: '日本', pid: 0, type: 'country'
  },
  {
    id: 2094, value: '马来西亚', pid: 0, type: 'country'
  },
];

export default {
  name: 'SignInfoForm',
  mixins: [permissionMixin],
  components: {
    jmDictSelect,
    jmUploadFile,
    jmSchoolSearch,
    schoolLogs,
    krFormDialog
  },
  props: {
    formData: {
      type: Object,
      default() {
        return {};
      }
    },
    ds: {
      type: Object,
      default() {
        return {};
      }
    },
    teachers: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      countryCheckboxLock: [false],
      material_send: '',
      isSpecialChannel: false,
      active_country_name: [],
      editData: {
        material_send: '',
        interview_special_channel: 0,
        signup_form: {},
        cms_sayer_country: 0,
        korea_school_type: '无',
        // kr_fst_id: '',
        // kr_sec_id: '',
        // kr_thr_id: '',
        // kr_fou_id: '',
      },
      saveSchoolType: 0, // 重置记录
      krSchool: {
        crm_id: 0,
        school_type: 0
      },
      krSchoolVisible: false,
      koreaSchoolName: null,
      dictUUCountries: UUCountries,
      dictUCCountries: UCCountries,
      active_countries: [],
      active_countries_old: [],
      interviewSchool: null,
      originInterviewSchool: {}, // 原面试学校
      currentInterviewObj: {
        signup_form: null
      },
      showSchoolLogs: false,
      uploadedSignForm: null, // 上传的报名表
      uploadedSignFormReplaced: null, // 上传的报名表过渡
      updateChannelText: '',
      showSchool: {
        kr_fir_id: null,
        kr_sec_id: null,
        kr_thr_id: null,
        kr_fou_id: null
      },
      buttonStyle: 'info',
      origin_korea_school_type: '',
      contractFlagOps: [
        {
          value: 1,
          label: '是'
        },
        {
          value: 2,
          label: '否'
        }
      ],
    };
  },
  created() {
    this.editData = { ...this.formData, ...this.editData };
    this.$nextTick(() => {
      this.material_send = this.editData.material_send;
      if (!this.editData.custom_active_country) {
        this.editData.custom_active_country = [];
      }
      if (!this.editData.custom_active_country[0] || this.editData.custom_active_country.length < 1) {
        vueClint.set(this.countryCheckboxLock, 0, true);
      }
      this.active_countries = this.editData.custom_active_country;
      this.active_countries_old = this.active_countries.slice(0);
    });
  },
  methods: {
    isInHopeCountry(countries) {
      return _.intersection(this.editData.custom_hope_country, countries).length > 0;
    },
    isInActiveCountry(countries) {
      return _.intersection(this.editData.custom_active_country, countries).length > 0;
    },
    downloadDzxy() {
      window.open(this.$jiemo.imghome + this.editData.dzxy_file);
    },
    uploadDzxySuccess({ msg, result, data }) {
      if (result === -1) {
        this.$message.error(msg);
        return false;
      }
      this.$message.success('电子协议上传成功');
      this.editData.dzxy_file = data.path;
    },
    countryCheckboxClick(val) {
      if (val === 1) {
        vueClint.set(this.countryCheckboxLock, 0, !this.countryCheckboxLock[0]);
      }
    },
    setKrSchool() {
      if (this.showSchool.kr_fir_id === null && this.editData.korea_school_type !== '无') {
        this.buttonStyle = 'primary';
      }
      if ((this.showSchool.kr_fir_id === null && this.editData.korea_school_type === '无') || (this.showSchool.kr_fir_id === '' && this.editData.korea_school_type === '无')) {
        this.buttonStyle = 'info';
      }
      this.origin_korea_school_type = this.editData.korea_school_type;
      this.showSchool.kr_fir_id = this.editData.kr_fir_id;
      this.showSchool.kr_sec_id = this.editData.kr_sec_id;
      this.showSchool.kr_thr_id = this.editData.kr_thr_id;
      this.showSchool.kr_fou_id = this.editData.kr_fou_id;
      if (typeof (this.showSchool.kr_fir_id) !== 'undefined') {
        this.buttonStyle = 'success';
        this.currentKoreaSchool();
      }
    },
    async currentKoreaSchool(obj) {
      const { data } = await this.$http._post({
        url: '/index/student/currentKoreaSchool',
        data: { id: this.editData.id }
      });
      if (data) {
        if (data.kr_fir_id) {
          this.showSchool.kr_fir_id = data.kr_fir_id.sh_name_cn;
        }
        if (data.kr_sec_id) {
          this.showSchool.kr_sec_id = data.kr_sec_id.sh_name_cn;
        }
        if (data.kr_thr_id) {
          this.showSchool.kr_thr_id = data.kr_thr_id.sh_name_cn;
        }
        if (data.kr_fou_id) {
          this.showSchool.kr_fou_id = data.kr_fou_id.sh_name_cn;
        }
      }
      if (obj) {
        this.origin_korea_school_type = obj.save_school_type;
        if (obj.kr_fir_id !== null || obj.kr_sec_id !== null || obj.kr_thr_id !== null || obj.kr_fou_id !== null) {
          this.buttonStyle = 'success';
        } else if ((this.showSchool.kr_fir_id === null && this.editData.korea_school_type === '无') || (this.showSchool.kr_fir_id === '' && this.editData.korea_school_type === '无')) {
          this.buttonStyle = 'info';
        } else if (typeof (this.showSchool.kr_fir_id) === 'undefined' && this.editData.korea_school_type !== '无') {
          this.buttonStyle = 'primary';
        }
      }
    },
    resetType() {
      this.editData.korea_school_type = '无';
    },
    chooseCountries() {
      this.active_country_name = [];
      this.editData.custom_active_country.forEach((item) => {
        for (let i = 0; i < this.activeCountry.length; i++) {
          if (item === this.activeCountry[i].id) {
            this.active_country_name.push(this.activeCountry[i].value);
          }
        }
      });
      return this.active_country_name;
    },
    viewSignForm(id) {
      window.open(`${this.editData.interview_form_url}&hid=${id}`);
    },
    changeCountries(data, item) {
      let txtArr = [];
      if (data.length > 0) {
        data.forEach((item1) => {
          item.forEach((item2) => {
            if (item1 === item2.id) {
              txtArr.push(item2.value);
            }
          });
        });
        this.editData.custom_active_country = data;
        this.editData.custom_active_country_str = txtArr;
      } else {
        this.editData.custom_active_country = [];
        this.editData.custom_active_country_str = [];
      }
      this.$emit('update:form-data', this.editData);
    },
    isInArray(arr, value) {
      for (let i = 0; i < arr.length; i++) {
        if (value === arr[i]) {
          return true;
        }
      }
      return false;
    },
    isUA() {
      let hpCountry = this.editData.custom_hope_country;
      let isUA = false;
      let signCountry = [30, 31, 674, 673, 675, 1831, 1770];
      for (let i = 0; i < hpCountry.length; i++) {
        if (this.isInArray(signCountry, hpCountry[i])) {
          isUA = true;
          break;
        }
      }
      return isUA;
    },
    bindUserSignStatus(val) {
      // 英澳必须选择签约类型
      let isUA = this.isUA();
      if (val === 7 && !this.editData.radio_and_check && isUA) {
        this.$message.error('请选择签约类型');
        return false;
      }

      if (val === 7 && this.isLanguageSchool && !this.$hasPermission([1])) {
        if (!this.editData.custom_month) {
          this.$alert('请填写入学时间', '提示', {
            confirmButtonText: 'OK'
          });
        }
        this.$alert('签约时请选择申请学校', '提示', {
          confirmButtonText: '知道了'
        }).then(() => {
          this.$refs.school_search.focus();
        }).catch(() => {});
      }

      if (val === 7 && this.editData.crm_level_lv !== 57) {
        this.editData.crm_level_lv = 57;
        if (!this.editData.signing_date) {
          this.editData.signing_date = new Date();
        }
        return true;
      }

      if (val === 9 && this.editData.crm_level_lv !== 65) {
        this.editData.crm_level_lv = 65;
      }
    },
    beforeSignupFileUpload() {
      if (this.editData.custom_course_type === 1) {
        // 前程日本语言学校学生
        if (this.editData.crm_level_lv !== 57) {
          this.$message.error('签约后才能上传报名表');
          return false;
        }
      }
      return true;
    },
    updateCurrentInterview(interview) {
      this.currentInterviewObj = Object.assign(
        {},
        this.currentInterviewObj,
        interview
      );
    },
    changeSendMetrial(v) {
      this.editData.material_send = v;
      this.$emit('update:form-data', this.editData);
    },
    /**
     * 选择学校
     */
    async selectSchool(v) {
      if (!v) {
        return false;
      }

      let message = '选择学校后，学生即将开始面试流程';
      if (this.originInterviewSchool) {
        message = `您确认要将学生学校修改为“${v.sh_name_cn}”吗？`;
      }

      try {
        await this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        });
        await this.startInterviewPlan(v);
        this.interviewSchool = v;
      } catch (e) {
        console.log('取消选择新的学校，还原原有学校');
        this.interviewSchool = this.originInterviewSchool
          ? { ...this.originInterviewSchool }
          : null;
      }
    },
    /**
     * 开启面试计划
     */
    async startInterviewPlan(school) {
      const { data } = await this.$http._post({
        url: '/interview/plan/start',
        data: {
          school,
          userId: this.editData.id,
          term: this.interviewTerm
        }
      });
      this.$message({
        message: '选择面试学校成功',
        type: 'success'
      });
      this.updateCurrentInterview(data);
    },

    async currentInterview() {
      const { data } = await this.$http._post({
        url: '/index/student/currentVisibleInterview',
        data: { id: this.editData.id }
      });
      if (data) {
        this.currentInterviewObj = data;
        this.interviewSchool = {
          interview_id: data.id,
          interview_is_special: data.is_special,
          sh_id: data.school_id,
          sh_name_cn: data.school_name,
          sh_name_en: data.school_name_en,
          value: data.school_name
        };
        this.originInterviewSchool = { ...this.interviewSchool };
      }
    },
    /**
     * 确认特殊报名表
     */
    async confirmInterview() {
      try {
        await this.$confirm(
          '确认后报名表将同步到面试系统，请老师确认内容',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        );
      } catch (e) {
        return false;
      }
      const { data } = await this.$http._post({
        url: '/interview/plan/confirmInterview',
        data: {
          id: this.currentInterviewObj.id,
          term: this.interviewTerm,
          school: this.interviewSchool
        }
      });
      this.updateCurrentInterview(data);
      this.$message.success('预约面试成功！');
    },
    /**
     * 检测如果是签约，学校必填
     */
    checkSchoolStatus() {
      if (this.$hasPermission([1])) {
        return true;
      }

      if (
        this.editData.custom_level === 7 ||
          this.editData.crm_level_lv === 57
      ) {
        if (this.isLanguageSchool && !this.interviewSchool) {
          this.$refs.school_search.focus();
          throw new Error('申请学校必须填写');
        }

        if (!this.editData.custom_month) {
          throw new Error('入学时间不能为空');
        }
        const hopeCountry = this.editData.custom_hope_country;
        const writer = this.editData.crm_writer;
        if (hopeCountry.includes(672)) {
          if (!writer) {
            this.$refs.crmWriterSelect.focus();
            throw new Error('申请老师不能为空');
          }
        }
        const planningTeacher = this.editData.crm_planning;
        const crmDocument = this.editData.crm_document;
        if (hopeCountry.includes(83)) {
          if (!writer && !crmDocument) {
            throw new Error('申请老师和文书老师选择一处必填');
          }
          if (!planningTeacher) {
            throw new Error('规划老师不能为空');
          }
        }
      }
      return true;
    },
    downloadCert(cert) {
      this.$http.getFile({ url: cert.file_path, filename: cert.filename });
    },
    addClass(id) {
      let active = '';
      this.dictUUCountries.forEach((item) => {
        if (item.id === id) {
          active = 'blueCountries';
        }
      });
      this.dictUCCountries.forEach((item) => {
        if (item.id === id) {
          active = 'redCountries';
        }
      });
      return active;
    },
    async showKrSchool(type) {
      // 选择
      if (type === 1) {
        if (this.origin_korea_school_type !== '无') {
          if (this.editData.korea_school_type !== '无' && this.origin_korea_school_type !== '') {
            if (this.editData.korea_school_type !== this.origin_korea_school_type) {
              await this.showReset();
              return;
            }
          }
        }
      }
      // 按钮
      if (type === 2) {
        if (this.editData.korea_school_type === '' || this.editData.korea_school_type === '无') {
          this.$message.error('请先选择项目类型');
          return;
        }
      }
      this.krSchoolVisible = true;
      this.krSchool.crm_id = this.editData.id;
      this.krSchool.school_type = this.editData.korea_school_type;
    },

    async showReset () {
      let message = '此操作会重置学生的选校记录,是否继续?';
      try {
        await this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        });
        await this.resetKoreaSchool();
        // 刷新
      } catch (e) {
        this.$message.success('已取消');
        this.editData.korea_school_type = this.origin_korea_school_type;
      }
    },

    async resetKoreaSchool() {
      const { data } = await this.$http._post({
        url: '/index/student/resetKoreaSchool',
        data: { id: this.editData.id }
      });
      if (data) {
        if (data.result) {
          this.buttonStyle = 'info';
          this.editData.korea_school_type = '无';
          this.origin_korea_school_type = '';
          this.showSchool.kr_fir_id = null;
          this.showSchool.kr_sec_id = null;
          this.showSchool.kr_thr_id = null;
          this.showSchool.kr_fou_id = null;
          this.$refs.kr.resetSchool();
          this.$message.success('重置学校成功');
        } else {
          this.$message.error('重置学校失败');
        }
      }
    },
    showInterviewBtn(id) {
      if (this.editData.custom_hope_country.includes(id)) {
        return true;
      }
      return false;
    },
  },
  computed: {
    activeCountry() {
      let newCountry = [];
      if (this.ds.country) {
        let l = this.ds.country.length;
        for (let i = 0; i < l; i++) {
          newCountry.push(this.ds.country[i]);
        }
      }
      return newCountry;
    },
    /**
     * 编辑代言人禁用
     */
    rugbyDisable() {
      // 其他系统信息只读
      if (!this.isFibSite) {
        return true;
      }
      if (!this.isNew) {
        if (this.$hasPermission([1, 89, 62])) {
          return false;
        }
        return true;
      }
      return false;
    },
    /**
     * 资料发送数据
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {Array}
     */
    materialData() {
      let countries = [];
      this.editData.custom_hope_country.forEach((item) => {
        if (item === 83 || item === 485) {
          countries.push('ziliao_jp');
          return true;
        }

        if (item === 30) {
          countries.push('ziliao_uk');
          return true;
        }

        if (item === 31) {
          countries.push('ziliao_aus');
          return true;
        }
      });
      return this.ds.material.filter(item => countries.indexOf(item.type) > -1);
    },
    /**
     * 是否为日本语言学校资源
     */
    isLanguageSchool() {
      return this.$inCountry([83]) && this.isInHopeCountry([83]);
    },
    /**
     * 是否为韩国资源
     */
    isKoreaSchool() {
      return this.isInHopeCountry([672]) || this.isInActiveCountry([672]);
    },
    /**
     * 面试学期
     */
    interviewTerm() {
      return `${this.editData.custom_year}-${this.editData.custom_month}-01`;
    },
    /**
     * 可以确认面试学校
     */
    canConfirmSchool() {
      if (!this.currentInterviewObj) {
        return false;
      }

      if (
        isEmpty(this.editData.signup_form) &&
          isEmpty(this.uploadedSignForm)
      ) {
        return false;
      }

      // 上一个面试学校与新选择的不是同一个
      return !this.currentInterviewObj.is_current;
    },
    /**
     * 必须有报名表
     */
    mustHaveInterviewForm() {
      return this.isInHopeCountry([83, 672, 2061]);
    },
    /**
     * 是否有报名表
     */
    hasSignUpForm() {
      return !isEmpty(this.editData.signup_form);
    },
  },
  watch: {
    editData: {
      handler(v) {
        this.$emit('update:form-data', v);
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isLanguageSchool && this.currentInterview();
      if (this.isKoreaSchool) {
        this.setKrSchool();
      }
    });
  }
};
</script>

<style scoped>
  .c-spe {
    padding-right: 20px;
  }
  .blueCountries span.el-checkbox__label {
    color: #3368fa;
  }
</style>
<style >
  .blueCountries span.el-checkbox__label {
    color: #3368fa;
  }
  .redCountries span.el-checkbox__label {
    color: #F75694;
  }
  .activeCountry {
    display: flex;
    justify-content: flex-start;
  }
  .activeCountry_box {
    width: 4.16667%;
    justify-content: flex-end;
    font-size: 14px;
    padding-right: 5px;
    font-weight: bold;
  }
  .activeCountry_checkbox {
    /* flex: 11; */
    width: 95.83333%;
  }

</style>
